import { LocaleEnum } from "@/types/utils/locale";

import locales from "./locales/locales.json";

export const fallbackLng = LocaleEnum.TH;
export const languages = Object.keys(locales);
export const defaultNS = "translation";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    debug: false,
    supportedLngs: languages,
    fallbackLng,
    lowerCaseLng: true,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    load: "currentOnly" as "all" | "currentOnly" | "languageOnly",
    interpolation: { escapeValue: false },
  };
}
